import endpoints, { axios } from "../../config/api";

async function deleteFile(folderId: string, fileId: string) {
  return await (await axios.delete(endpoints.newfolders.file(folderId, fileId)))
    .data;
}

export default deleteFile;
